import { render, staticRenderFns } from "./TeacherGroupStudents.vue?vue&type=template&id=a19ef2be&scoped=true&"
import script from "./TeacherGroupStudents.vue?vue&type=script&lang=js&"
export * from "./TeacherGroupStudents.vue?vue&type=script&lang=js&"
import style0 from "./TeacherGroupStudents.vue?vue&type=style&index=0&id=a19ef2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19ef2be",
  null
  
)

export default component.exports